module.exports = __webpack_public_path__ + "assets/dynatrace.e0fe5142.svg";